import React from "react";

const LOGO_URL = "https://benton.lightideaproductions.co.uk/logo.png";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[rgba(8,17,31,0.78)] backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1800px] flex-col gap-3 px-4 py-5 text-sm text-white/60 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Benton Theatres Logo"
            className="h-10 w-10 rounded-xl object-contain"
          />
          <div>Benton Theatres</div>
        </div>

        <div>Online Booking System</div>
      </div>
    </footer>
  );
}